import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { UserStore } from '@ss/shared/user';

@Component({
	selector: 'nta-change-facility',
	templateUrl: './change-facility.dialog.html',
	styleUrls: ['./change-facility.dialog.scss'],
	imports: [MatDialogModule, MatButtonModule, MatFormFieldModule, MatSelectModule, FormsModule]
})
export class ChangeFacilityDialog {
	userStore = inject(UserStore);

	selectedFacility = signal(this.userStore.currentFacilityId());
}
